var _style, _g, _path, _path2, _path3, _defs, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBeer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#315CA7;}\n\t.st1{fill:#F8AA37;}\n\t.st2{fill:#FECC50;}\n\t.st3{fill:#F39110;}\n\t.st4{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M104.75,182.9c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6s-77.3,34.29-77.3,76.6 C27.45,148.6,62.06,182.9,104.75,182.9"
  })))), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M141.1,135.33h-19.28c-5.32,0-9.64-4.33-9.64-9.64V87.12c0-5.32,4.33-9.64,9.64-9.64h19.28 c5.32,0,9.64,4.32,9.64,9.64v38.57C150.74,131,146.41,135.33,141.1,135.33 M121.81,87.12v38.57h14.46c0,0,4.82,0,4.82-4.82V91.94 c0-4.82-4.82-4.82-4.82-4.82H121.81z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M129.04,82.3c0-5.32-4.32-9.64-9.64-9.64H85.66c-5.33,0-9.64,4.32-9.64,9.64v57.85c0,5.33,4.32,9.64,9.64,9.64 l0,0h33.75c5.33,0,9.64-4.32,9.64-9.64l0,0V82.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M116.99,142.56c-1.33,0-2.41-1.08-2.41-2.41l0,0v-38.57c0-1.33,1.08-2.41,2.41-2.41s2.41,1.08,2.41,2.41v38.57 C119.4,141.48,118.32,142.56,116.99,142.56L116.99,142.56 M102.53,142.56c-1.33,0-2.41-1.08-2.41-2.41l0,0v-38.57 c0-1.33,1.08-2.41,2.41-2.41c1.33,0,2.41,1.08,2.41,2.41v38.57C104.94,141.48,103.86,142.56,102.53,142.56L102.53,142.56  M88.07,142.56c-1.33,0-2.41-1.08-2.41-2.41l0,0v-38.57c0-1.33,1.08-2.41,2.41-2.41c1.33,0,2.41,1.08,2.41,2.41v38.57 C90.48,141.48,89.4,142.56,88.07,142.56L88.07,142.56"
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M80.84,67.83c-2.66,0-4.82,2.16-4.82,4.82v72.31c0,2.66,2.16,4.82,4.82,4.82l0,0h43.39 c2.66,0,4.82-2.16,4.82-4.82V72.66c0-2.66-2.16-4.82-4.82-4.82H80.84z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M133.87,72.66c0-4.82-4.82-9.64-9.64-9.64H80.84c-4.82,0-9.64,4.82-9.64,9.64v4.82c0,0.23,0.04,0.45,0.07,0.67 c-0.05,1.38-0.07,2.77-0.07,4.15c-2.02,4.93,0.34,10.56,5.26,12.58c4.93,2.02,10.56-0.34,12.58-5.26c0.48-1.17,0.72-2.42,0.72-3.68 c1.98,1.74,5,1.54,6.74-0.44c0.12-0.14,0.23-0.28,0.34-0.43c1.76,2.78,4.82,4.46,8.11,4.47c3.01-0.01,5.85-1.43,7.66-3.84 c0.9,2.31,3.12,3.84,5.6,3.84c2.29,0,4.25-1.29,5.28-3.17c0.98,0.49,2.06,0.75,3.16,0.76c3.99,0,7.23-3.24,7.23-7.23l0,0 c0-0.75-0.01-1.42-0.04-2.05c0.01-0.12,0.04-0.24,0.04-0.36V72.66z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeer);
export default __webpack_public_path__ + "static/media/Beer.e87f2caf8c73c82be2bc2df135d70d9f.svg";
export { ForwardRef as ReactComponent };